import { Box, ColorOptions, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'

const BeneficiaryDetailsBox = ({ allValues, show }: any) => {
  // console.log('BeneficiaryDetailsBox data: ', allValues)
  return (
    <ModBox
      show={show}
      direction="row"
      h={56}
      borderRadius={4}
      backgroundColor={'#F4F4F4' as ColorOptions}
      alignItems={'center'}
      justifyContent={'space-between'}
      padding={16}>
      <Text title={allValues?.name} color={'BLACK'} fontFamily="jiotype-medium" fontSize={12} />
      <Box direction="row" alignItems={'center'}>
        <Icon id="LANDLINE" size={12} color={'#8E8E8E' as ColorOptions} />
        <Spacer size={6} direction="horizontal" />
        <Text title={`+91 ${allValues?.phone}`} color={'BLACK'} fontFamily="jiotype-medium" fontSize={12} />
      </Box>
      <Box backgroundColor={'WHITE'} borderRadius={4} paddingHorizontal={8} paddingVertical={4}>
        <Text title={allValues?.beneficiaryType} color={'BLACK'} fontFamily="jiotype-medium" fontSize={12} />
      </Box>
    </ModBox>
  )
}

export { BeneficiaryDetailsBox }
